import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  -moz-osx-font-smoothing: ", ";\n  -webkit-font-smoothing: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export var injectOSXFontSmoothing = function injectOSXFontSmoothing(enable) {
  return css(_templateObject(), enable ? 'grayscale' : 'auto', enable ? 'antialiased' : 'auto');
};